module.exports=[
    {
        path: '/',
        name: '建筑类综合资源平台',
        component: () => import('./views/Platform.vue'),
        meta: {
            noNeedLogin: true, // 判断是否需要登录
        },
    },
    {path: '*', component: () => import('./views/404.vue')}
]
